module.exports = __webpack_public_path__ + "static/media/advancing_travel.147b3dc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/advancing_travel.png
// module id = 253
// module chunks = 0